import { render, staticRenderFns } from "./FuelExpensesForm.vue?vue&type=template&id=8a57ef46&scoped=true&"
import script from "./FuelExpensesForm.vue?vue&type=script&lang=js&"
export * from "./FuelExpensesForm.vue?vue&type=script&lang=js&"
import style0 from "./FuelExpensesForm.vue?vue&type=style&index=0&id=8a57ef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a57ef46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
